/**
 * Nylas account.status from /synchronize (see NylasSynchronization).
 * Below 1: integration error. 1: linked but sync stopped. Above 1: operational.
 */

export function isNylasAccountSyncError(status) {
    return status !== null && status !== undefined && status < 1;
}

export function isNylasAccountSyncDelayed(status) {
    return status === 1;
}

export function isNylasAccountOperational(status) {
    return status > 1;
}

/** Mail/calendar features that require an active Nylas account. */
export function isNylasAccountSyncBlocked(status) {
    return !isNylasAccountOperational(status ?? 0);
}
